export default __webpack_public_path__ + "static/media/franquia2.a21a3130.png";